import { GameConstants } from "../../GameConstants";
import { BoardManagerAI } from "../BoardManagerAI";
import { AudioManager } from "../../AudioManager";

export class DifficultySelectionContainer extends Phaser.Group {

    private static DIFF_LEVELS: string[] = [GameConstants.DIFFICULTY_EASY, GameConstants.DIFFICULTY_MEDIUM, GameConstants.DIFFICULTY_HARD];

    private iDiff: number;
    private difficultyLabel: Phaser.Text;

    constructor(game: Phaser.Game) {

        super(game, null, "color-selection-container");

        this.iDiff = 0;

        const difficultyLabel = new Phaser.Text(this.game, 0, -150, "Difficulty", { font: "46px Roboto Slab Bold", fill: GameConstants.TEXT_COLOR_WHITE, align: "center"}); 
        difficultyLabel.anchor.x = .5;
        this.add(difficultyLabel);

        const diffSelectionBackground: Phaser.Sprite = this.create(0, -50, this.game.cache.getBitmapData(GameConstants.WHITE_SQUARE));
        diffSelectionBackground.anchor.set(.5);
        diffSelectionBackground.scale.set(210 / GameConstants.BITMAP_SIZE, 70 / GameConstants.BITMAP_SIZE);
        this.add(diffSelectionBackground);

        this.difficultyLabel = new Phaser.Text(this.game, 0, -44, DifficultySelectionContainer.DIFF_LEVELS[this.iDiff], { font: "32px Roboto Slab Regular", fill: "#1b2d3d", align: "center"}); 
        this.difficultyLabel.anchor.set(.5);
        this.add(this.difficultyLabel);

        const leftArrowButton = new Phaser.Button(this.game, -100, -50, "texture_atlas_1", this.onClickArrowButton, this);
        leftArrowButton.setFrames("button_arrow_capsule_on.png", "button_arrow_capsule_off.png", "button_arrow_capsule_on.png");
        leftArrowButton.angle = 180;
        leftArrowButton.name = GameConstants.LEFT;
        leftArrowButton.anchor.y = .5;
        leftArrowButton.forceOut = true;
        this.add(leftArrowButton);

        const rightArrowButton = new Phaser.Button(this.game, 100, -50, "texture_atlas_1", this.onClickArrowButton, this);
        rightArrowButton.setFrames("button_arrow_capsule_on.png", "button_arrow_capsule_off.png", "button_arrow_capsule_on.png");
        rightArrowButton.name = GameConstants.RIGHT;
        rightArrowButton.anchor.y = .5;
        rightArrowButton.forceOut = true;
        this.add(rightArrowButton);
    }

    private onClickArrowButton(b: Phaser.Button): void {

        if (b.name === GameConstants.RIGHT) {
            this.iDiff = this.iDiff < 2 ? this.iDiff + 1 : 0;
        } else {
            this.iDiff = this.iDiff > 0 ? this.iDiff - 1 : 2;
        }

        this.difficultyLabel.text = DifficultySelectionContainer.DIFF_LEVELS[this.iDiff];

        BoardManagerAI.setDifficulty(DifficultySelectionContainer.DIFF_LEVELS[this.iDiff]);

        AudioManager.playSound("click"); 
    }
}
